import { CircularProgress } from "@mui/material";
import React from "react";

function Loader() {
  return (
    <div className="sweet-loading">
      <CircularProgress size={50} />
    </div>
  );
}

export default Loader;
